import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { MapPin, ThumbsUp, Plus } from "lucide-react";

export default function VotePage() {
  const { user } = useAuth();
  const [leaderboard, setLeaderboard] = useState([]);
  const [myCities, setMyCities] = useState([]);
  const [newCity, setNewCity] = useState("");

  const refresh = async () => {
    const l = await api.get("/votes/leaderboard");
    setLeaderboard(l.data.leaderboard || []);
    if (user) {
      const m = await api.get("/votes/mine");
      setMyCities(m.data.cities || []);
    }
  };
  useEffect(() => { refresh(); }, [user]);

  const vote = async (city) => {
    if (!user) return toast.error("Log in to vote.");
    try {
      await api.post("/votes", { city_name: city });
      toast.success(`Voted for ${city}`);
      refresh();
    } catch {
      toast.error("Vote failed");
    }
  };

  const submitNewCity = async (e) => {
    e.preventDefault();
    if (!newCity.trim()) return;
    await vote(newCity.trim());
    setNewCity("");
  };

  return (
    <div className="py-8 space-y-8">
      <div>
        <div className="overline">Your city. Your hunt.</div>
        <h1 className="font-display uppercase text-5xl md:text-6xl tracking-tight mt-2">
          Vote the next <span style={{ color: "#76B82A" }}>drop</span>
        </h1>
        <p className="text-[#F5F2E8]/70 mt-3 max-w-xl">
          Hype your hometown. Most-requested cities get drops first.
        </p>
      </div>

      <form onSubmit={submitNewCity} className="flex flex-col sm:flex-row gap-3" data-testid="vote-new-city-form">
        <input
          className="loot-input flex-1"
          placeholder="Request a city (e.g. Kingsport, TN)"
          value={newCity}
          onChange={(e) => setNewCity(e.target.value)}
          data-testid="vote-new-city-input"
        />
        <button className="btn-gold inline-flex items-center gap-2" data-testid="vote-new-city-submit">
          <Plus size={16} /> Add & vote
        </button>
      </form>

      <div className="loot-card-flat">
        <div className="p-4 section-border overline">Top requested cities</div>
        {leaderboard.length === 0 && <div className="p-6 text-[#F5F2E8]/50">No votes yet.</div>}
        {leaderboard.map((row, i) => (
          <div
            key={row.city}
            className="flex items-center justify-between p-4 border-b border-[#F5F2E8]/10 last:border-b-0"
            data-testid={`vote-row-${row.city}`}
          >
            <div className="flex items-center gap-4">
              <span className="font-display text-3xl w-10" style={{ color: i === 0 ? "#D7A62A" : "#F5F2E8" }}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <div className="font-display uppercase text-xl flex items-center gap-2">
                  <MapPin size={16} className="text-[#76B82A]" /> {row.city}
                </div>
                <div className="font-mono text-xs text-[#F5F2E8]/50">{row.votes} votes</div>
              </div>
            </div>
            <button
              onClick={() => vote(row.city)}
              className={`btn-ghost text-xs flex items-center gap-1 ${
                myCities.includes(row.city) ? "text-[#76B82A] border-[#76B82A]" : ""
              }`}
              data-testid={`vote-btn-${row.city}`}
            >
              <ThumbsUp size={14} /> {myCities.includes(row.city) ? "Voted" : "Vote"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
